import AccessTimeIcon from '@mui/icons-material/AccessTime'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material'
import AnnouncementIcon from 'assets/images/announcement_icon.svg'
import React, {useState} from 'react'

import {getLogoByCarriernotification} from 'config/logo.constant'
import {useDispatch, useSelector} from 'react-redux'
import {type RootState, type AppDispatch} from 'redux/store'
import {deactivateNotification} from 'features/Notifications/notification.slice'
import {getFormattedDate} from 'utils/helperFunctions'

interface MessageNotificationsProps {
    messageId: string
    messageType: string
    messageTitle: string
    descriptionHeader: string
    description: string
    carrier: string
    displayFrom: string
    displayTo: string
}

const MessageNotifications: React.FC<MessageNotificationsProps> = ({
    messageId,
    messageType,
    messageTitle,
    descriptionHeader,
    description,
    carrier,
    displayFrom,
    displayTo
}) => {
    const theme = useTheme()
    const dispatch = useDispatch<AppDispatch>()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [open, setOpen] = useState(true)
    const completeLogos = useSelector((state: RootState) => state.login.completeLogos)
    const userId = useSelector((state: any) => state.login.loginDetails?.securityParams?.userID)

    const handleClose = () => {
        setOpen(false)
    }
    const okayHandler = () => {
        if (messageType !== 'Maintenance') {
            const payload = {
                userId,
                messageId
            }
            void dispatch(deactivateNotification(payload))
        }
        handleClose()
    }
    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (event.target === event.currentTarget) {
            handleClose()
        }
    }

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                onClick={handleBackdropClick}
                id='mainDialogContainer'
            >
                <DialogTitle className='headerContainer'>
                    <div className='headerTitle'>
                        {messageType !== 'Maintenance' ? (
                            <>
                                <div className='iconStyle'>
                                    <img src={AnnouncementIcon} alt='Announcement Img' className='iconStyle' />
                                </div>
                                <div className=''>{messageTitle}</div>
                            </>
                        ) : (
                            <>
                                <div className='iconStyle2'>{<AccessTimeIcon></AccessTimeIcon>}</div>
                                <div className='headerTitle2'>{messageTitle}</div>
                            </>
                        )}
                    </div>
                </DialogTitle>

                <DialogContent dividers className='msgDiv'>
                    <div className='MsgContentContainer'>
                        <img
                            src={getLogoByCarriernotification(completeLogos, carrier)}
                            alt='carrier-icon'
                            className='carrierImages'
                        />
                        <div className='description'>
                            {descriptionHeader && <Typography>{descriptionHeader}</Typography>}
                            <div dangerouslySetInnerHTML={{__html: description}} />
                        </div>
                        <Typography variant='body2' className='msg-reference'>
                            Message Reference: {messageId} <br />
                            Display: {getFormattedDate(displayFrom, 'DDMMMYY hh:mm:ss')} -{' '}
                            {getFormattedDate(displayTo, 'DDMMMYY hh:mm:ss')}
                        </Typography>
                    </div>
                </DialogContent>
                <DialogActions className='btn'>
                    <Button variant='contained' onClick={okayHandler} className='okaybtn'>
                        Okay
                    </Button>
                    {messageType !== 'Maintenance' && (
                        <Button variant='text' onClick={handleClose} className='rmlbtn'>
                            Remind me later
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default MessageNotifications
